
/* injects from baggage-loader */

'use strict';

export default class AnimatedSuccessCircleController {

	constructor($log) {
		'ngInject';

		this.$log = $log;

	}

	$onInit() {

	}

}
